import { render } from "./ExhibitorCard.vue?vue&type=template&id=3648a5d0&scoped=true"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js"

import "./ExhibitorCard.vue?vue&type=style&index=0&id=3648a5d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3648a5d0"]])

export default __exports__